import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MyFilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'myFilterFabrica',
  pure: false
})
export class MyFilterFabricaPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(items: any[], filter: any): any {
      if (!items || !filter) {
          return items;
      }

      //console.log('itens',items);

      // filter items array, items which match and return true will be
      // kept, false will be filtered out
      return items.filter(item => item.fabrica == filter.fabrica);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/my-filter-fabrica/my-filter-fabrica.ts